import React, { Component } from "react";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { observer } from "mobx-react";
import { store } from "../store";
import Tab from "./Tab";
import { CurrentTheme } from "theme";

export default observer(
  class Header extends Component {

    tabList = [
        {
            key: 'campaign',
            name: 'Campaign'
        },
        {
            key: 'audience',
            name: 'Audience'
        }
    ]


    render() {
      const tabs = (this.tabList.map(({ key, name }) => {
          return <Tab
            key={key}
            name={name}
            selected={store.selectedTab == key}
            onClick={() => (store.selectedTab = key)}
          />
      }))      

      return (
        <Wrapper>
          {tabs}
        </Wrapper>
      );
    }
  }
);

const Wrapper = styled.div`
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  display: flex;
  & > div:first-child {
    border-right: 1px solid ${props => props.theme.panelBorder};
    border-radius: 4px 0 0 0;
  }
`;



// WEBPACK FOOTER //
// ./src/module-email-campaign/header/HeaderWithStoreQuery.js